import '@styles/common.less';
import '@styles/layout.less';
import './contact.less';
import '@common';
import provinceDistrictMap from './province-data';

const renderOptions = (selectEl, values, placeholder) => {
  const options = [`<option value="" selected disabled>${placeholder}</option>`]
    .concat(values.map((value) => `<option value="${value}">${value}</option>`))
    .join('');
  selectEl.innerHTML = options;
};

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.section .form');
  if (!form) return;
  const provinceSelect = form.querySelector('[name="province"]');
  const districtSelect = form.querySelector('[name="district"]');
  const provinceList = Object.keys(provinceDistrictMap);

  renderOptions(provinceSelect, provinceList, 'เลือกจังหวัด');

  provinceSelect.addEventListener('change', () => {
    const selectedProvince = provinceSelect.value;
    const districtList = provinceDistrictMap[selectedProvince] || [];

    districtSelect.disabled = districtList.length === 0;
    renderOptions(districtSelect, districtList, 'เลือกเขต/อำเภอ');
  });

  let submitting = false
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    // 浏览器已校验 required / email，此处构建 JSON 用于后续 fetch
    const payload = {
      name: form.querySelector('[name="name"]').value.trim(),
      phone: form.querySelector('[name="phone"]').value.trim(),
      email: form.querySelector('[name="email"]').value.trim(),
      province: provinceSelect.value,
      district: districtSelect.value,
    };
    if (submitting) return
    submitting = true

    fetch('https://services.leadconnectorhq.com/hooks/6HJoYRUzivooBXtS4B1C/webhook-trigger/3429db31-4ce7-409e-a0c5-ef9f63031aed', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(res => res.json())
    .then(data => {
      submitting = false
      alert('Your information has been successfully submitted. We will get in touch with you shortly.')
    })
    .catch(err => {
      submitting = false
      alert('Failed to submit, try again later.')
    })
  });
})